module.exports = {
      id: "home-usage",
      viewBox: "0 0 15.417 13.987",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#home",
      toString: function () {
        return this.url;
      }
    }